import { CALL_API } from "admin/middlewares/api";

export const APPLICATION_TASKS_ASSING_REQUEST =
  "APPLICATION_TASKS_ASSING_REQUEST";
export const APPLICATION_TASKS_ASSING_SUCCESS =
  "APPLICATION_TASKS_ASSING_SUCCESS";
export const APPLICATION_TASKS_ASSING_ERROR = "APPLICATION_TASKS_ASSING_ERROR";

export function assign_task_applications(number) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/assign",
      authenticatedRequest: true,
      method: "POST",
      data: { MaxCount: number },
      types: [
        APPLICATION_TASKS_ASSING_REQUEST,
        { method: assign_task_success },
        APPLICATION_TASKS_ASSING_ERROR,
      ],
    },
  };
}

function assign_task_success(response) {
  return (dispatch, getState) => {
    let { applications } = getState();
    dispatch({
      type: APPLICATION_TASKS_ASSING_SUCCESS,
      response,
      applications,
    });
  };
}

export const APPLICATION_TASKS_GET_REQUEST = "APPLICATION_TASKS_GET_REQUEST";
export const APPLICATION_TASKS_GET_SUCCESS = "APPLICATION_TASKS_GET_SUCCESS";
export const APPLICATION_TASKS_GET_ERROR = "APPLICATION_TASKS_GET_ERROR";

export function get_task_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/session",
      authenticatedRequest: true,
      method: "GET",
      types: [
        APPLICATION_TASKS_GET_REQUEST,
        { method: get_task_success },
        APPLICATION_TASKS_GET_ERROR,
      ],
    },
  };
}

function get_task_success(response) {
  return (dispatch, getState) => {
    let { applications } = getState();
    dispatch({
      type: APPLICATION_TASKS_GET_SUCCESS,
      response,
      applications,
    });
  };
}

export const APPLICATION_TASKS_GET_OTHERS_REQUEST =
  "APPLICATION_TASKS_GET_OTHERS_REQUEST";
export const APPLICATION_TASKS_GET_OTHERS_SUCCESS =
  "APPLICATION_TASKS_GET_OTHERS_SUCCESS";
export const APPLICATION_TASKS_GET_OTHERS_ERROR =
  "APPLICATION_TASKS_GET_OTHERS_ERROR";

export function get_allsessions_task_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/allsessions",
      authenticatedRequest: true,
      method: "GET",
      types: [
        APPLICATION_TASKS_GET_OTHERS_REQUEST,
        APPLICATION_TASKS_GET_OTHERS_SUCCESS,
        APPLICATION_TASKS_GET_OTHERS_ERROR,
      ],
    },
  };
}

export const INIT_APPLICATION_TASKS_GET_REQUEST =
  "INIT_APPLICATION_TASKS_GET_REQUEST";
export const INIT_APPLICATION_TASKS_GET_SUCCESS =
  "INIT_APPLICATION_TASKS_GET_SUCCESS";
export const INIT_APPLICATION_TASKS_GET_ERROR =
  "INIT_APPLICATION_TASKS_GET_ERROR";

export function init_task_applications() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/init",
      authenticatedRequest: true,
      method: "POST",
      types: [
        INIT_APPLICATION_TASKS_GET_REQUEST,
        INIT_APPLICATION_TASKS_GET_SUCCESS,
        INIT_APPLICATION_TASKS_GET_ERROR,
      ],
    },
  };
}

export const DROP_APPLICATION_TASK_GET_REQUEST =
  "DROP_APPLICATION_TASK_GET_REQUEST";
export const DROP_APPLICATION_TASK_GET_SUCCESS =
  "DROP_APPLICATION_TASK_GET_SUCCESS";
export const DROP_APPLICATION_TASK_GET_ERROR =
  "DROP_APPLICATION_TASK_GET_ERROR";

export function drop_task_applications(Id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/applications/dropsingle",
      authenticatedRequest: true,
      method: "POST",
      data: { ApplicationId: Id },
      types: [
        DROP_APPLICATION_TASK_GET_REQUEST,
        DROP_APPLICATION_TASK_GET_SUCCESS,
        DROP_APPLICATION_TASK_GET_ERROR,
      ],
    },
  };
}

export const APPLICATION_TASKS_LIST_CHANGE_PAGE =
  "APPLICATION_TASKS_LIST_CHANGE_PAGE";

export function change_application_list_page(page) {
  return {
    type: APPLICATION_TASKS_LIST_CHANGE_PAGE,
    page,
  };
}

export const APPLICATION_TASKS_LIST_CHANGE_FILTER =
  "APPLICATION_TASKS_LIST_CHANGE_FILTER";

export function change_application_list_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: APPLICATION_TASKS_LIST_CHANGE_FILTER,
    filter,
  };
}
